const FlowStatistics = () =>
  import(
    /* webpackChunkName: "flowStatistics" */ '../../pages/flowStatistics/index.vue'
  )
const FlowStatisticsPaySuccess = () =>
  import(
    /* webpackChunkName: "flowStatistics" */ '../../pages/flowStatistics/paySuccess.vue'
  )
export default [
  {
    path: '/flowStatistics',
    meta: { title: '流量统计' },
    component: FlowStatistics
  },
  {
    path: '/flowStatistics/paySuccess',
    meta: { title: '流量统计' },
    component: FlowStatisticsPaySuccess
  }
]
